export default "__VITE_ASSET__CiXHY7Ui__"